import React from "react";
import { Form, Input, Button, Modal } from "antd";
import api from "../../api/api/index";
import queryString from "query-string";
import { withTranslation } from "react-i18next";

function error(title, content) {
  Modal.error({ title, content });
}

class ForgotPassword extends React.Component {
  handleFormSubmit = (e) => {
    e.preventDefault();
    const { t } = this.props;

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const email = values.email;
        const finalBody = { email };

        fetch(`${api.main}/forgot_password`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          body: queryString.stringify(finalBody),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then((res) => {
            if (res.status !== 105 && res.status !== 104) {
              Modal.error({
                title: t("common:error"),
                content: res.message || t("forgotPassword:unknownError"),
                onOk: () => {
                  this.props.history.push("/forgotpassword");
                },
              });
            } else {
              Modal.success({
                title: t("forgotPassword:passwordResetTitle"),
                content: t("forgotPassword:passwordResetBody"),
                onOk: () => {
                  this.props.history.push("/");
                },
              });
            }
          })
          .catch((err) => {
            Modal.error({
              title: t("common:error"),
              content: t("forgotPassword:sendFailed"),
              onOk: () => {
                this.props.history.push("/forgotpassword");
              },
            });
            console.error("Error:", err);
          });
      } else {
        Modal.error({
          title: t("common:error"),
          content: t("forgotPassword:invalidEmail"),
          onOk: () => {
            this.props.history.push("/forgotpassword");
          },
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { t } = this.props;

    return (
      <div className="container mt-4">
        <div className="spare-dvs vh-100 align-items-start">
          <div className="w-100 float-left">
            <div style={{ padding: "8px" }}>
              <img
                src={process.env.PUBLIC_URL + "/images/spare_logo_s.png"}
                alt="Spare Logo"
                className="responsive-image"
                style={{ maxWidth: "30%" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                paddingTop: "20px",
                height: "100vh",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  paddingTop: "20px",
                  height: "100vh",
                }}
              >
                <p style={{ marginBottom: "10px", fontSize: "15px" }}>
                  {t("forgotPassword:prompt")}
                </p>

                <Form onSubmit={this.handleFormSubmit} style={{ width: "300px" }}>
                  <Form.Item>
                    {getFieldDecorator("email", {
                      rules: [
                        { required: true, message: t("forgotPassword:emailRequired") },
                      ],
                    })(
                      <Input
                        type="email"
                        placeholder={t("forgotPassword:emailPlaceholder")}
                        style={{ width: "100%" }}
                      />
                    )}
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "150px", marginTop: "10px" }}
                    >
                      {t("forgotPassword:submit")}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Form.create()(withTranslation(["forgotPassword", "common"])(ForgotPassword));
